import { IonButton as Button, IonText as Text } from '@ionic/react';
import React from 'react';
import styled from 'styled-components';
import { t } from 'ttag';

import { ReactComponent as Image } from '@assets/download-new-app.svg';
import Product from '@custom-types/Product';
import Layout from '@pages/Auth/Layout';
import { openLink } from '@services/store-link-service';

const Container = styled.div`
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const IonText = styled(Text)`
  font-weight: 500;
  text-align: center;
  margin: 10px 0;
`;

const IonButton = styled(Button)`
  width: 100%;
`;

const NewAppAvailable = () => (
  <Layout hideFooter hideLogo>
    <Container>
      <Image />
      <IonText>
        <h1>{t`New App Now Available!`}</h1>
      </IonText>
      <IonText>
        <p>{t`Thanks to feedback from our amazing customers, we have separated our app to provide a better experience. `}</p>
        <p>{t`Select the feature you would like to access and download our new app to get started! `}</p>
      </IonText>

      <IonButton
        expand="block"
        // skipcq: JS-0417
        onClick={() => openLink(Product.CheckIn)}
      >{t`Check In`}</IonButton>
      <IonButton
        expand="block"
        // skipcq: JS-0417
        onClick={() => openLink(Product.LeadCapture)}
      >{t`Lead Capture`}</IonButton>
    </Container>
  </Layout>
);

export default NewAppAvailable;
